define(['require', 'exports'], function (require, exports) {
    'use strict';

    /**
     * @type {ng.IAngularStatic}
     */
    var angular = require('angular');

    /**
     * Directive for drawing the lightbox
     * Using Bootstrap's Modal Component
     */
    exports.metLightbox = function () {
        return {
            restrict: 'E',
            scope: {
                lightboxName: '@name', // The name of the modal element; String
                closeIcon: '@showCloseIcon', // Show the close (x) icon; Boolean
                closeButton: '@showCloseButton', // Show the close button within a footer; Boolean
                closeButtonLabel: '@', // The label of the close button; String
                show: '=showOnLoad', // Show the modal on page load (also shows the modal every time it changes from false to true); Boolean
                animate: '@', // Enables the animation of the modal; Boolean
                size: '@', // The size of the modal, Bootstrap style: sm, lg, empty for default; String
                backdrop: '@clickBackdrop',
                customClasses: '@', // Any classes to add to the modal element, separated by space; String
                actionOnClose: '&',
                infiniteScrollCallback: '&?',
                infiniteScrollAvailable: '=?',
                infiniteScrollLoading: '=?'
            },
            replace: true,
            transclude: true,
            link: {
                pre: function (scope, element) {
                    element.remove();
                    angular.element('.pageContainer').prepend(element);
                },
                post: function (scope, element, attrs, ctrls, transcludeFn) {
                    var modalElement = element.find('.modal');
                    var modalDialog = element.find('.modal-dialog');
                    var modalBackdrop = element.find('.modal-backdrop');

                    scope.lightboxName = scope.lightboxName || 'myModal';
                    scope.closeButtonLabel = scope.closeButtonLabel || 'Close';

                    modalElement.addClass(scope.customClasses);

                    if (scope.animate) {
                        modalElement.addClass('fade');
                    }

                    if (scope.size) {
                        modalDialog.addClass('modal-' + scope.size);
                    }

                    if (!scope.backdrop) {
                        modalElement.data('backdrop', 'static');
                    }

                    if (scope.backdrop) {
                        modalBackdrop.on('mouseup', function () {
                            scope.$apply(function () {
                                scope.show = false;
                            });
                            scope.actionOnClose && scope.actionOnClose();
                        });
                    }

                    if (scope.infiniteScrollCallback && scope.infiniteScrollAvailable){
                        element.find('.modal-content').scroll(function(){
                            if(scope.infiniteScrollAvailable && !scope.infiniteScrollLoading && angular.element(this).scrollTop() + angular.element(this).innerHeight() === this.scrollHeight) {
                                scope.infiniteScrollCallback();
                            }
                        });
                    }

                    scope.$watch('show', function (newValue) {
                        if (newValue) {
                            modalElement.removeClass('hide').addClass('fade in');
                            modalBackdrop.removeClass('hide').addClass('fade in');

                            angular.element('body').css({overflow: 'visible'});
                            angular.element('html').css({overflow: 'visible', position: 'fixed', width: '100%'}).addClass('lightbox-open'); // hack for firefox on android

                        } else {
                            modalElement.addClass('hide').removeClass('fade in');
                            modalBackdrop.addClass('hide').removeClass('fade in');

                            angular.element('body').css({overflow: 'auto'});
                            angular.element('html').css({overflow: 'auto', position: 'static'}).removeClass('lightbox-open'); // hack for firefox on android
                        }

                    });

                    modalElement.on('hide.bs.modal', function () {

                        if (!scope.show) {
                            return;
                        }

                        scope.$apply(function () {
                            scope.show = false;
                        });

                    });

                    scope.closeModal = function () {
                        scope.show = false;
                        scope.actionOnClose && scope.actionOnClose();
                    };

                    transcludeFn(scope.$parent, function(clone){
                        element.find('[met-transclude]').append(clone);
                    });


                }
            },
            template:
            '<div class="met-lightbox">' +
            '   <div class="modal hide" id="{{lightboxName}}" tabindex="-1" role="dialog" aria-labelledby="{{lightboxName}}Label">' +
            '       <div class="modal-dialog" role="document">' +
            '           <div class="modal-content">' +
            '               <button type="button" ng-show="{{closeIcon}}" class="close lightbox-close-x" data-dismiss="modal" aria-label="Close" ng-click="closeModal()">' +
            '                   <span aria-hidden="true"><i class="fa fa-times"></i></span>' +
            '               </button>' +
            '              <div met-transclude></div>' +
            '              <div class="met-footer" ng-show="{{closeButton}}">' +
            '                  <button type="button" class="pull-right btn btn-default" ng-click="closeModal()">{{closeButtonLabel}}</button>' +
            '              </div>' +
            '          </div>' +
            '      </div>' +
            '   </div>' +
            '   <div class="modal-backdrop hide"></div>' +
            '</div>'
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/metLightbox.js